export function convertToDateFormat(dateTimeString) {
  if (dateTimeString) return dateTimeString?.split("T")[0];
  return "";
}

export function toTitleCase(text) {
  return text
    .replace(/([A-Z])/g, " $1") // add space before capital letters
    .replace(/^./, (str) => str.toUpperCase()) // capitalize first letter
    .trim();
}

/** Quantity and rate fields must not be negative; invalid numbers become 0. */
export function clampQtyRateValue(value) {
  const n = typeof value === "number" ? value : parseFloat(value);
  return Math.max(0, Number.isFinite(n) ? n : 0);
}